import HeaderMenuDesktop from "./HeaderMenuDesktop"
import HeaderMenuMobile from "./HeaderMenuMobile"
import { usePageContext } from "vike-react/usePageContext"

export default function Navbar() {
  const pageContext = usePageContext()
  const currentPath = pageContext?.currentPath || pageContext?.urlPathname || (typeof window !== 'undefined' ? window.location.pathname : '/')
  
  const shouldHide = currentPath?.startsWith('/admin') ||
                    (typeof window !== 'undefined' && window.location.pathname.startsWith('/admin'))
  
  if (shouldHide) return null
  
  return (
    <div // Ensures the layout sections following the header are not hidden behind it
      className="relative flex h-0 lg:h-[80px] w-full flex-col items-center justify-center"
      style={{ zIndex: 200 }}
    >
      <div className="hidden lg:flex">
        <HeaderMenuDesktop />
      </div>

      <div className="flex lg:hidden">
        <HeaderMenuMobile />
      </div>
    </div>
  )
}